import {
  STRUCTURED_CONTENT_COMPONENTS_BASE,
  STRUCTURED_CONTENT_COMPONENTS_LEARN_CONTENT_OVERRIDES,
} from '@cc-shopping/structured-content-renderer/config';
import { createStructuredContentRenderer } from '@cc-shopping/structured-content-renderer/createRenderer';
import type { StructuredContent } from '@cc-shopping/structured-content-renderer/hydration/types';
import {
  renderStructuredContent,
  setRenderer,
} from '@cc-shopping/structured-content-renderer/renderContext';
import { CreditCardsLPCardList } from './components/CreditCardsLPCardList';
import { CreditCardsLPOfferBlock } from './components/CreditCardsLPOfferBlock';
import { CreditCardsMultiCompare } from './components/CreditCardsMultiCompare';
import { CreditCardsMultiCompareSection } from './components/CreditCardsMultiCompare/CreditCardsMultiCompareSection';
import { CreditCardsMultiCompareSectionItem } from './components/CreditCardsMultiCompare/CreditCardsMultiCompareSectionItem';
import { Link } from './components/Link';
import { MiniProductCard } from './components/MiniProductCard';
import { RoundupPicksSummary } from './components/RoundupPicksSummary';
import { WPHouseAd } from './components/WPHouseAd';

const APP_STRUCTURED_CONTENT_COMPONENTS = {
  ...STRUCTURED_CONTENT_COMPONENTS_BASE,
  CreditCardsLPCardList,
  CreditCardsLPOfferBlock,
  CreditCardsMultiCompare,
  CreditCardsMultiCompareSection,
  CreditCardsMultiCompareSectionItem,
  CreditCardsRoundupPicksSummary: RoundupPicksSummary,
  Link,
  MiniProductCard,
  WPHouseAd,
};

const { renderDoc } = createStructuredContentRenderer(
  APP_STRUCTURED_CONTENT_COMPONENTS,
  STRUCTURED_CONTENT_COMPONENTS_LEARN_CONTENT_OVERRIDES,
);

setRenderer(renderDoc);

export function StructuredContentRenderer({
  doc,
  useLearnContentOverrides = false,
}: {
  doc: StructuredContent;
  useLearnContentOverrides?: boolean;
}) {
  return renderStructuredContent(doc, useLearnContentOverrides);
}
